<div class="org">

  <!-- Cabeçalho -->
  <header class="org-cabecalho">
    <i class="fa fa-sitemap"></i>
    <h1>Organograma DIVIPREV</h1>
    <p>Estrutura por setor e equipe</p>
  </header>

  <div class="org-grid">
    <div *ngFor="let setor of setores; trackBy: trackPorGrupo"
         class="org-no surgir"
         [style.animation-delay.ms]="setor._delay">
      <ng-container *ngTemplateOutlet="cardSetor; context: { $implicit: setor }"></ng-container>
    </div>
  </div>
</div>


<!-- ============================================================= -->
<!-- Template reutilizável de um setor (cabeçalho + pessoas)        -->
<!-- ============================================================= -->
<ng-template #cardSetor let-setor>
  <div class="setor">

    <div class="setor-titulo">
      <i class="fa" [ngClass]="setor.icone"></i>
      <span>{{ setor.nome || setor.id }}</span>
      <small *ngIf="!setor.carregando && !setor.erro" class="setor-contagem">
        {{ setor.pessoas.length }}
      </small>
    </div>

    <!-- Carregando -->
    <div *ngIf="setor.carregando" class="setor-estado">
      <i class="fa fa-spinner fa-spin"></i> carregando…
    </div>

    <!-- Erro -->
    <div *ngIf="setor.erro" class="setor-estado setor-estado--erro" (click)="recarregar(setor)">
      <i class="fa fa-exclamation-triangle"></i> falha ao carregar — tentar novamente
    </div>

    <!-- Vazio -->
    <div *ngIf="!setor.carregando && !setor.erro && !setor.pessoas.length" class="setor-estado">
      <i class="fa fa-user-times"></i> sem pessoas cadastradas
    </div>

    <!-- Pessoas -->
    <div *ngIf="!setor.carregando && !setor.erro && setor.pessoas.length" class="setor-pessoas">
      <div *ngFor="let pes of setor.pessoas; trackBy: trackPorEmail"
           class="pessoa surgir"
           [style.animation-delay.ms]="pes._delay">
        <div class="pessoa-foto">
          <img [src]="pes.foto | pipeFoto" [alt]="pes.nome">
        </div>
        <div class="pessoa-nome">{{ pes.nome }}</div>
        <div class="pessoa-funcao">{{ pes.funcao }}</div>
        <div *ngIf="pes.email" class="pessoa-email" (click)="enviarEmail(pes.email)" title="{{ pes.email }}">
          <i class="fa fa-envelope-o"></i> {{ usuarioEmail(pes.email) }}
        </div>
        <div *ngIf="pes.origem" class="pessoa-origem">{{ pes.origem }}</div>
      </div>
    </div>

  </div>
</ng-template>
